import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { PRODUCT_TYPES } from '../constants';
import { formatPrice, calculateTotalPrice } from './index';

// Ana Renk - Bronz/Kahve
const PRIMARY_COLOR = [153, 20, 20]; // #991414
const SECONDARY_COLOR = [125, 21, 21]; // #7d1515
const LIGHT_BG = [253, 243, 243]; // #fdf3f3
const GRAY_TEXT = [100, 100, 100];

// QR Kodları (Web sitesi ve Instagram)
const QR_WEBSITE_BASE64 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADIAQMAAACXljzdAAAABlBMVEX///8AAABVwtN+AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAA+0lEQVRYhdWXwQ7DIAxDky/nz5OBbVg7rfc6TKjj9VAL46YRjzUaNa86KiIruVDvJnj2xpjLNae1kL5k6WzwSo6p055g7r13/mT9sGn2RE6E2P7nUS+ipFhj+/CeIV7k1MJ5+W9KBnVigkjFhSsJph73Dj7M0hmzJINvJUUFPbjsWK6kJTX4ZtKZSlsS7IJgxaJY8lcTRltIRF5PliXB1sBvzGlJLVvS6g5CeZ3senxJx6EptesOT7ILXGF9bQ7cyKABQc6xylsn5EWok/NRmsak1Y2ufvSbFv6Elcw+f9Lfb4T8/XK1InQijpd2jo40JbwOZkXsMG9X8lgfuJifIk4BlHgAAAAASUVORK5CYII=';

const QR_INSTAGRAM_BASE64 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADIAQMAAACXljzdAAAABlBMVEX///8AAABVwtN+AAAACXBIWXMAAA7EAAAOxAGVKw4bAAABiUlEQVRYhdWYsRGDMAxF5aNwyQiM4s1ij8YoHoGSwoei/w0kXC41QoUv6KVA8PVtIfI3siJkWO2nrZNqYGZzQF68waDryITOEhpSzsmgWq0S5DbLJA3N/lSeQFDPnLXFmspziEhckqIqfQbp2mlxofgrfl9UdSPp3QiSymbdOOdrn/okn0hld5Kf8Ef46LGYQrZBK6parCrf5IUahJVIf/5UEJ3PL7GrZbIL+DW1bk7S34JnkntXnn6N2vb3czsxZ6NC6MoKbjFp8U2y5ap0D6Erq7axdufzS2wvWQ6P7ooOkEwR10RABFqmX9tKnp0TkbGyA835JCI37PU4JtlUMxU4Cbp1xclO6doOCBQyHWcgxb5tewl2Q+fE/BjPfNzdg/VIdk7ofDzh565orInTlF/SIxzdyP0Fg5Vvwq2F51E433pOU+Ka9LO/0PMCCUzlMxXcSvZJD6dOu/dv7TyArGdVdOVnkEYxt4gvGNSM+CbUDsgMXaMbj7nEMTm7kV8BIqcpvfapQ/I33vDSwkoJiw9SAAAAAElFTkSuQmCC';

// Türkçe karakter temizleme fonksiyonu
const cleanTurkishChars = (text) => {
  return (text || '').replace(/[ğ]/g, 'g')
    .replace(/[Ğ]/g, 'G')
    .replace(/[ü]/g, 'u')
    .replace(/[Ü]/g, 'U')
    .replace(/[ş]/g, 's')
    .replace(/[Ş]/g, 'S')
    .replace(/[ı]/g, 'i')
    .replace(/[İ]/g, 'I')
    .replace(/[ö]/g, 'o')
    .replace(/[Ö]/g, 'O')
    .replace(/[ç]/g, 'c')
    .replace(/[Ç]/g, 'C');
};

// Modern Header çiz
const drawHeader = (doc, title, subTitle = '', variant = 'white') => {
  if (variant === 'white') {
    // Beyaz arkaplan, kırmızı yazılar (Müşteri ve Teklif PDF'leri)
    doc.setFillColor(255, 255, 255);
    doc.rect(0, 0, 210, 38, 'F');

    // Alt ayırıcı border
    doc.setDrawColor(...PRIMARY_COLOR);
    doc.setLineWidth(0.8);
    doc.line(15, 38, 195, 38);

    doc.setTextColor(...PRIMARY_COLOR);

    // Firma adı
    doc.setFontSize(18);
    doc.setFont('helvetica', 'bold');
    doc.text('PERDESOR CONCEPT', 20, 13);

    // Firma alt adı (biraz daha küçük)
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.text('PERDESOR PERDE SISTEMLERI', 20, 19);

    // Belge tipi (Teklif Formu, Siparis Detayi, ...)
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.text(cleanTurkishChars(title), 20, 28);

    // Opsiyonel alt başlık
    if (subTitle) {
      doc.setFontSize(9);
      doc.setFont('helvetica', 'normal');
      doc.text(cleanTurkishChars(subTitle).toUpperCase(), 20, 34);
    }

    // Sağ taraf - QR Kodları (Web sitesi ve Instagram)
    // QR Kod 1 - Web Sitesi (perdesor.com)
    doc.addImage(QR_WEBSITE_BASE64, 'PNG', 149, 5, 20, 20);
    doc.setFontSize(6.5);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...PRIMARY_COLOR);
    doc.text('perdesor.com', 159, 29, { align: 'center' });
    doc.link(149, 5, 20, 26, { url: 'https://perdesor.com' });

    // QR Kod 2 - Instagram (@perdesor_concept)
    doc.addImage(QR_INSTAGRAM_BASE64, 'PNG', 174, 5, 20, 20);
    doc.setFontSize(6.5);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...PRIMARY_COLOR);
    doc.text('Instagram', 184, 29, { align: 'center' });
    doc.link(174, 5, 20, 26, { url: 'https://www.instagram.com/perdesor_concept/' });

    // Reset text color
    doc.setTextColor(0, 0, 0);
  } else {
    // Üst banner (Kırmızı arkaplan, beyaz yazılar - Atölye / Montaj)
    doc.setFillColor(...PRIMARY_COLOR);
    doc.rect(0, 0, 210, 38, 'F');

    doc.setTextColor(255, 255, 255);

    // Firma adı
    doc.setFontSize(18);
    doc.setFont('helvetica', 'bold');
    doc.text('PERDESOR CONCEPT', 20, 13);

    // Firma alt adı (biraz daha küçük)
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.text('PERDESOR PERDE SISTEMLERI', 20, 19);

    // Belge tipi (Teklif Formu, Siparis Detayi, ...)
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.text(cleanTurkishChars(title), 20, 28);

    // Opsiyonel alt başlık (ör. müşteri adı - Atölye PDF)
    if (subTitle) {
      doc.setFontSize(9);
      doc.setFont('helvetica', 'normal');
      doc.text(cleanTurkishChars(subTitle).toUpperCase(), 20, 34);
    }

    // Sağ taraf - İletişim
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.text('Tel: +90 530 886 02 06', 190, 13, { align: 'right' });
    doc.text('perdesorconceptcom@gmail.com', 190, 20, { align: 'right' });
    doc.text('Merkez Mah. Baglar Caddesi No:5D Kagithane / Istanbul', 190, 27, { align: 'right' });

    // Reset text color
    doc.setTextColor(0, 0, 0);
  }
};

// Modern Footer çiz
const drawFooter = (doc) => {
  const pageHeight = doc.internal.pageSize.height;

  // Alt çizgi
  doc.setDrawColor(...PRIMARY_COLOR);
  doc.setLineWidth(0.5);
  doc.line(15, pageHeight - 25, 195, pageHeight - 25);

  // İletişim Bilgileri
  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...PRIMARY_COLOR);
  doc.text('Tel: +90 530 886 02 06   |   perdesorconceptcom@gmail.com   |   Merkez Mah. Baglar Caddesi No:5D Kagithane / Istanbul', 105, pageHeight - 19, { align: 'center' });

  // Footer slogan ve sistem bilgisi
  doc.setFontSize(7.5);
  doc.setTextColor(...GRAY_TEXT);
  doc.text('Perdesor Concept - Perdede Cozum Ortaginiz', 105, pageHeight - 14, { align: 'center' });
  doc.text('Bu belge bilgisayar ortaminda olusturulmustur.', 105, pageHeight - 9, { align: 'center' });

  // Sayfa numarası
  const pageCount = doc.internal.getNumberOfPages();
  doc.text(`Sayfa ${doc.internal.getCurrentPageInfo().pageNumber} / ${pageCount}`, 195, pageHeight - 9, { align: 'right' });

  doc.setTextColor(0, 0, 0);
};

// Metni satırlara böl
const splitTextToLines = (text, maxCharsPerLine) => {
  const words = text.split(' ');
  const lines = [];
  let currentLine = '';

  words.forEach(word => {
    if ((currentLine + ' ' + word).trim().length <= maxCharsPerLine) {
      currentLine = (currentLine + ' ' + word).trim();
    } else {
      if (currentLine) lines.push(currentLine);
      currentLine = word;
    }
  });
  if (currentLine) lines.push(currentLine);
  return lines;
};

/** Atölye PDF kutusunda gösterilecek ek satırları oluşturur (not hariç) */
const buildWorkshopOrderExtraLines = (order) => {
  const items = [];

  const pushSpacer = () => {
    if (items.length > 0) items.push({ spacer: true });
  };

  if (order.productType === 'tul' && (order.altEtekKatlama || order.hasAltEtekKatlama)) {
    items.push({ text: 'Alt Etek Katlama olacak', color: 'primary' });
  }

  if (order.productType === 'kanat') {
    const ozelName = order.ozelTasarimProductName || order.ozelProductName;
    const hasOzel = (order.hasOzelTasarim || ozelName) && ozelName;
    if (hasOzel) {
      pushSpacer();
      const ozelVariant = order.ozelTasarimProductVariant || order.ozelProductVariant;
      let ozelLine = `Ozel Tasarim: ${ozelName}`;
      if (ozelVariant) ozelLine += ` - ${ozelVariant}`;
      items.push({ text: ozelLine, color: 'primary', bold: true });

      const ozelPile = order.ozelTasarimPileModel || order.ozelPileModel;
      if (ozelPile) {
        items.push({ text: `Pile: ${ozelPile}`, color: 'primary' });
      }

      const dims = [];
      const oWidth = order.ozelTasarimWidth || order.ozelWidth;
      const oHeight = order.ozelTasarimHeight || order.ozelHeight;
      const oQty = order.ozelTasarimQuantity || order.ozelQuantity || '1';
      if (oWidth) dims.push(`En: ${oWidth}`);
      if (oHeight) dims.push(`Boy: ${oHeight}`);
      const dimPart = dims.length ? dims.join('  ') : '';
      const adetPart = `Adet: ${oQty}`;
      items.push({
        text: dimPart ? `${dimPart}  ${adetPart}` : adetPart,
        color: 'primary'
      });
    }

    const hasAstar = (order.hasAstar || order.astarProductName) && order.astarProductName;
    if (hasAstar) {
      pushSpacer();
      let astarLine = `Astar: ${order.astarProductName}`;
      if (order.astarProductVariant) astarLine += ` - ${order.astarProductVariant}`;
      items.push({ text: astarLine, color: 'black' });
    }

    const accs = Array.isArray(order.kanatAccessories) && order.kanatAccessories.length > 0
      ? order.kanatAccessories.filter((a) => a.name)
      : (Array.isArray(order.accessories) ? order.accessories.filter((a) => a.name) : []);

    if (accs.length > 0) {
      pushSpacer();
      accs.forEach((acc) => {
        const isMetre = acc.unitType === 'metre' || acc.unit === 'metre';
        const detail = isMetre
          ? `${acc.meter || acc.metre || '1'} m x ${acc.quantity || '1'} ad`
          : `${acc.quantity || '1'} ad`;
        items.push({ text: `Aksesuar: ${acc.name} (${detail})`, color: 'black' });
      });
    }
  }

  return items.map((item) => {
    if (item.spacer) return item;
    return { ...item, text: cleanTurkishChars(item.text) };
  });
};

/** Atölye PDF kutusu yüksekliğini içeriğe göre hesaplar */
const calcWorkshopBoxHeight = (extraItems, noteLines) => {
  let lineCount = 0;
  extraItems.forEach((item) => {
    if (item.spacer) {
      lineCount += 1;
      return;
    }
    const wrapped = splitTextToLines(item.text, 42);
    lineCount += Math.min(wrapped.length, 2);
  });
  const noteLineCount = Math.min(noteLines.length, 3);
  const noteBlockHeight = noteLineCount > 0 ? (extraItems.length > 0 ? 12 : 7) + noteLineCount * 5 : 0;
  const innerHeight = 26 + lineCount * 5 + noteBlockHeight;
  return Math.max(63, 14 + innerHeight + 6);
};

// Müşteri bilgileri kutusu
const drawCustomerInfoBox = (doc, customerInfo, startY, variant = 'white') => {
  const cleanName = cleanTurkishChars(customerInfo.name || '');
  const cleanAddress = cleanTurkishChars(customerInfo.address || '');

  // Adresi satırlara böl (maks 60 karakter per satır)
  const addressLines = splitTextToLines(cleanAddress, 60);
  const extraLines = Math.max(0, addressLines.length - 1);
  const boxHeight = 45 + (extraLines * 7);

  // Kutu arka planı ve çerçevesi
  if (variant === 'white') {
    doc.setFillColor(255, 255, 255);
    doc.setDrawColor(...PRIMARY_COLOR);
    doc.setLineWidth(0.5);
    doc.roundedRect(15, startY, 180, boxHeight, 3, 3, 'FD');
  } else {
    doc.setFillColor(...LIGHT_BG);
    doc.roundedRect(15, startY, 180, boxHeight, 3, 3, 'F');
  }

  // Sol taraf - Müşteri bilgileri
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...PRIMARY_COLOR);
  doc.text('MUSTERI BILGILERI', 20, startY + 10);

  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(0, 0, 0);
  doc.text(`Ad Soyad: ${cleanName}`, 20, startY + 20);
  doc.text(`Telefon: ${customerInfo.phone1 || '-'}`, 20, startY + 28);

  if (customerInfo.tcNo) {
    doc.text(`TC / Vergi No: ${customerInfo.tcNo}`, 100, startY + 28);
  }

  // Adres satırları
  let addressY = startY + 36;
  addressLines.forEach((line, index) => {
    const prefix = index === 0 ? 'Adres: ' : '       ';
    doc.text(`${prefix}${line}`, 20, addressY);
    addressY += 7;
  });

  // Sağ taraf - Tarihler
  if (customerInfo.orderDate || customerInfo.deliveryDate) {
    doc.setFontSize(9);
    doc.setTextColor(...GRAY_TEXT);

    if (customerInfo.orderDate) {
      const orderDate = customerInfo.orderDate?.toDate ? customerInfo.orderDate.toDate() : new Date(customerInfo.orderDate);
      doc.text(`Siparis: ${orderDate.toLocaleDateString('tr-TR')}`, 190, startY + 20, { align: 'right' });
    }

    if (customerInfo.deliveryDate) {
      const deliveryDate = customerInfo.deliveryDate?.toDate ? customerInfo.deliveryDate.toDate() : new Date(customerInfo.deliveryDate);
      doc.text(`Teslimat: ${deliveryDate.toLocaleDateString('tr-TR')}`, 190, startY + 28, { align: 'right' });
    }
  }

  doc.setTextColor(0, 0, 0);
  return startY + boxHeight + 8;
};

// Toplam tutar kutusu - Sağda alt alta format (Beyaz arka plan, kırmızı çerçeve ve yazılar)
const drawTotalBox = (doc, totalAmount, discountedTotalAmount, genelIskontoYuzde, vadeliYuzde, startY, showPaymentInfo = false, paidAmount = 0, remainingAmount = 0, showDetailedPricing = true, manualGrandTotal = null) => {
  const vYuzde = parseFloat(vadeliYuzde) || 0;
  const gIskonto = parseFloat(genelIskontoYuzde) || 0;

  const hasVade = vYuzde > 0;
  const hasIskonto = gIskonto > 0;
  const hasProductDiscount = discountedTotalAmount !== totalAmount && discountedTotalAmount > 0;

  // Hesaplamalar
  const vadeliToplam = totalAmount + (totalAmount * vYuzde / 100);
  const iskontoluToplam = totalAmount - (totalAmount * gIskonto / 100);

  // Hiyerarşi (Genel Toplam): Manuel Giriş > Vade Farkı > Genel İskonto > Ürün İndirimi > Ara Toplam
  let grandTotal = totalAmount;
  if (manualGrandTotal !== null && manualGrandTotal !== undefined && manualGrandTotal !== '') {
    grandTotal = parseFloat(manualGrandTotal);
  } else if (hasVade) {
    grandTotal = vadeliToplam;
  } else if (hasIskonto) {
    grandTotal = iskontoluToplam;
  } else if (hasProductDiscount) {
    grandTotal = discountedTotalAmount;
  }

  // Kutu yüksekliğini hesapla
  let itemCount = 1; // Sadece Genel toplam (alt sınır)
  if (showDetailedPricing) {
    itemCount += 1; // Ara toplam
    if (hasProductDiscount) itemCount++;
    if (hasIskonto) itemCount += 2; // % + tutar
    if (hasVade) itemCount += 2; // % + tutar
  }

  if (showPaymentInfo) {
    itemCount += 2; // Ödenen + Kalan
  }
  const boxHeight = 20 + (itemCount * 10);

  // Ana kutu (Beyaz arka plan, Kırmızı kenarlık)
  doc.setFillColor(255, 255, 255);
  doc.setDrawColor(...PRIMARY_COLOR);
  doc.setLineWidth(0.8);
  doc.roundedRect(100, startY, 95, boxHeight, 3, 3, 'FD');

  doc.setTextColor(...PRIMARY_COLOR);
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');

  let lineY = startY + 12;

  if (showDetailedPricing) {
    // Ara Toplam (Brüt)
    doc.text('Ara Toplam:', 105, lineY);
    doc.text(`${formatPrice(totalAmount)} TL`, 190, lineY, { align: 'right' });
    lineY += 9;

    // Ürün İndirimli Toplam
    if (hasProductDiscount) {
      doc.text('Urun Indirimli Toplam:', 105, lineY);
      doc.text(`${formatPrice(discountedTotalAmount)} TL`, 190, lineY, { align: 'right' });
      lineY += 9;
    }

    // Genel İskonto
    if (hasIskonto) {
      doc.text(`Genel Iskonto Tutari (%${genelIskontoYuzde}):`, 105, lineY);
      doc.text(`-${formatPrice(totalAmount * gIskonto / 100)} TL`, 190, lineY, { align: 'right' });
      lineY += 9;

      doc.text('Iskontolu Toplam:', 105, lineY);
      doc.text(`${formatPrice(iskontoluToplam)} TL`, 190, lineY, { align: 'right' });
      lineY += 9;
    }

    // Vade Farkı
    if (hasVade) {
      doc.text(`Vade Farki (%${vadeliYuzde}):`, 105, lineY);
      doc.text(`+${formatPrice(totalAmount * vYuzde / 100)} TL`, 190, lineY, { align: 'right' });
      lineY += 9;

      doc.text('Vadeli Toplam:', 105, lineY);
      doc.text(`${formatPrice(vadeliToplam)} TL`, 190, lineY, { align: 'right' });
      lineY += 9;
    }

    // Ayırıcı çizgi
    doc.setDrawColor(...PRIMARY_COLOR);
    doc.setLineWidth(0.4);
    doc.line(105, lineY - 2, 190, lineY - 2);
  }

  // Genel toplam
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.setTextColor(...PRIMARY_COLOR);
  doc.text('GENEL TOPLAM (Net):', 105, lineY + 6);
  doc.text(`${formatPrice(grandTotal)} TL`, 190, lineY + 6, { align: 'right' });

  if (manualGrandTotal !== null && manualGrandTotal !== undefined && manualGrandTotal !== '') {
    doc.setFontSize(7);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(...PRIMARY_COLOR);
    doc.text('(Elle Duzeltilmis)', 105, lineY + 11);
  }

  lineY += 14;

  // Ödenen ve Kalan bilgileri (sadece Müşteri PDF için)
  if (showPaymentInfo) {
    // Ayırıcı çizgi
    doc.setDrawColor(...PRIMARY_COLOR);
    doc.setLineWidth(0.4);
    doc.line(105, lineY - 2, 190, lineY - 2);

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.setTextColor(...PRIMARY_COLOR);

    // Ödenen
    doc.text('Odenen:', 105, lineY + 4);
    doc.text(`${formatPrice(paidAmount)} TL`, 190, lineY + 4, { align: 'right' });
    lineY += 9;

    // Kalan
    const isPaymentComplete = Math.abs(remainingAmount) < 0.01 || remainingAmount <= 0;
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...PRIMARY_COLOR);
    doc.text('Kalan:', 105, lineY + 4);
    if (isPaymentComplete) {
      doc.text('ODEME TAMAMLANDI', 190, lineY + 4, { align: 'right' });
    } else {
      doc.text(`${formatPrice(remainingAmount)} TL`, 190, lineY + 4, { align: 'right' });
    }
  }

  doc.setTextColor(0, 0, 0);
  return startY + boxHeight + 10;
};

// Müşteri PDF tablo verisini oluşturur
const buildCustomerTableData = (orders, includeMeasurements = true) => {
  const head = includeMeasurements
    ? [['Urun Tipi', 'Oda', 'Urun Adi', 'Olculer(cm)', 'Pile Modeli', 'Adet', 'Toplam Ucret (TL)', 'Indirimli (TL)']]
    : [['Urun Tipi', 'Oda', 'Urun Adi', 'Pile Modeli', 'Adet', 'Toplam Ucret (TL)', 'Indirimli (TL)']];

  const body = orders.flatMap((order) => {
    const cleanProductType = cleanTurkishChars(PRODUCT_TYPES[order.productType]?.label || order.productType || '');
    const cleanRoomName = cleanTurkishChars(order.roomName || '');
    let cleanPileModel = cleanTurkishChars(order.pileModel || '');
    const discountRate = parseFloat(order.discount) || 0;

    // Plise için özel satır bazlı genişletme
    if (order.productType === 'plise' && Array.isArray(order.pliseItems) && order.pliseItems.length > 0) {
      const p1Base = cleanTurkishChars(order.pliseProduct1Name || '');
      const p2Base = order.pliseProduct2Name ? ` + ${cleanTurkishChars(order.pliseProduct2Name)}` : '';

      return order.pliseItems.map((item) => {
        const ms = item.multisistem ? ' (Multisistem)' : '';
        const cleanProductName = item.multisistem ? (p1Base + p2Base + cleanTurkishChars(ms)) : p1Base;

        const row = [
          cleanProductType,
          cleanRoomName,
          cleanProductName
        ];

        if (includeMeasurements) {
          row.push(`${item.width || '-'} x ${item.height || '-'}`);
        }

        const rowTotal = parseFloat(item.rowTotal) || 0;
        const discountedRowTotal = rowTotal * (1 - discountRate / 100);

        row.push(
          '-', // Plise için pile modeli yok
          item.quantity || '1',
          formatPrice(rowTotal),
          discountRate > 0 ? formatPrice(discountedRowTotal) : '-'
        );

        return row;
      });
    }

    // Diğer ürün tipleri için tek satır
    let productName = order.productName || '';
    if (order.productVariant) productName += ` - ${order.productVariant}`;
    let nameSuffix = '';
    if (order.productType === 'tul' && order.hasAltEtekKatlama) {
      nameSuffix += ' (Alt Etek Katlama)';
    }
    if (order.direction) {
      nameSuffix += ` (${order.direction})`;
    }

    let cleanProductName = cleanTurkishChars(productName + nameSuffix);
    cleanPileModel = cleanTurkishChars(order.pileModel || '');
    let cleanMeasurements = `${order.width || ''} x ${order.height || ''}`;
    let cleanQuantity = `${order.quantity || '1'}`;

    const subDetailsLines = [];

    // Tül Aksesuarları
    if (order.productType === 'tul' && Array.isArray(order.kanatAccessories) && order.kanatAccessories.length > 0) {
      const accText = order.kanatAccessories.map((a) => {
        const detail = (includeMeasurements && a.unitType === 'metre')
          ? `${a.meter} m x ${a.quantity || 1} Adet`
          : `${a.quantity || 1} Adet`;
        return `${a.name} (${detail} - ${formatPrice(a.total)} TL)`;
      }).join(', ');
      subDetailsLines.push(cleanTurkishChars(`Aksesuarlar: ${accText}`));
    }

    // Kanat Özel Tasarım ve Aksesuarlar
    if (order.productType === 'kanat') {
      if (order.ozelTasarimProductName || order.hasOzelTasarim) {
        const ozelName = order.ozelTasarimProductName || 'Özel Kanat';
        const variantText = order.ozelTasarimProductVariant ? ` (${order.ozelTasarimProductVariant})` : '';
        const sizeText = includeMeasurements && order.ozelTasarimWidth && order.ozelTasarimHeight ? ` | ${order.ozelTasarimWidth}x${order.ozelTasarimHeight} cm` : '';
        const pileModelText = order.ozelTasarimPileModel ? ` | Pile: ${order.ozelTasarimPileModel}` : '';

        let ozelTotal = 0;
        if (order.ozelTasarimTotalPrice && parseFloat(order.ozelTasarimTotalPrice) > 0) {
          ozelTotal = parseFloat(order.ozelTasarimTotalPrice);
        } else if (order.ozelTasarimUsedM2 && order.ozelTasarimUnitPrice) {
          const ozelPrice = calculateTotalPrice(
            order.ozelTasarimUsedM2,
            order.ozelTasarimUnitPrice,
            order.ozelTasarimExtraPrice || 0,
            order.ozelTasarimPileModel,
            order.ozelTasarimCapsulePrice || 0
          );
          const ozelQuantity = parseFloat(order.ozelTasarimQuantity) || 1;
          ozelTotal = ozelPrice * ozelQuantity;
        }

        const cdText = `Ozel Tasarim: ${ozelName}${variantText}${sizeText}${pileModelText} | ${order.ozelTasarimQuantity || 1} Adet${ozelTotal > 0 ? ` | Tutar: ${formatPrice(ozelTotal)} TL` : ''}`;
        subDetailsLines.push(cleanTurkishChars(cdText));
      }
      if (order.astarProductName || order.hasAstar) {
        const astarName = order.astarProductName || 'Astar';
        const variantText = order.astarProductVariant ? ` (${order.astarProductVariant})` : '';
        const priceText = order.astarPrice && parseFloat(order.astarPrice) > 0 ? ` | Tutar: ${formatPrice(order.astarPrice)} TL` : '';
        subDetailsLines.push(cleanTurkishChars(`Astar: ${astarName}${variantText}${priceText}`));
      }

      if (Array.isArray(order.kanatAccessories) && order.kanatAccessories.length > 0) {
        const accText = order.kanatAccessories.map((a) => {
          const detail = (includeMeasurements && a.unitType === 'metre')
            ? `${a.meter} m x ${a.quantity || 1} Adet`
            : `${a.quantity || 1} Adet`;
          return `${a.name} (${detail} - ${formatPrice(a.total)} TL)`;
        }).join(', ');
        subDetailsLines.push(cleanTurkishChars(`Aksesuarlar: ${accText}`));
      }
    }

    const row = [
      cleanProductType,
      cleanRoomName,
      cleanProductName
    ];

    if (includeMeasurements) {
      row.push(cleanMeasurements);
    }

    row.push(
      cleanPileModel,
      cleanQuantity,
      formatPrice(order.totalPrice || 0),
      order.discountedPrice && parseFloat(order.discount) > 0 ? formatPrice(order.discountedPrice) : '-'
    );

    // Ray Sistemi için kullanılan metriği olculer sütununda göster (Müşteri PDF)
    if (order.productType === 'raySistemi' && includeMeasurements) {
      row[3] = `${order.width || ''} cm`; // Boy yok
      const usedMeter = order.usedMeter ? `${order.usedMeter} m` : '-';
      const olcu = order.olcuTamamlama ? ` (${order.olcuTamamlama})` : '';
      row[4] = cleanTurkishChars(order.olcuTamamlama || '-');
      row[3] = `${order.width || ''} cm\n${usedMeter}${olcu}`;
    }

    // Rustik için detayları göster
    if (order.productType === 'rustik' && includeMeasurements) {
      row[3] = `${order.width || ''} cm`; // Boy yok
      const usedCm = order.usedCm ? `${order.usedCm} cm` : '-';
      row[3] = `En: ${order.width || ''} cm\nKul: ${usedCm}`;

      let ayakDetay = cleanTurkishChars(order.ayakModel || '-');
      if (order.ayakSayisi) {
        ayakDetay += `\nAdet: ${order.ayakSayisi}`;
        if (order.ekAyakSayisi) ayakDetay += ` (+${order.ekAyakSayisi} Ek)`;
      }
      if (order.ayakCap || order.ayakRenkKodu) {
        ayakDetay += `\n(${order.ayakCap || ''} ${cleanTurkishChars(order.ayakRenkKodu || '')})`;
      }
      row[4] = ayakDetay;
    }

    const rows = [row];
    if (subDetailsLines.length > 0) {
      const totalCols = includeMeasurements ? 8 : 7;
      rows.push([
        {
          content: subDetailsLines.join('\n'),
          colSpan: totalCols,
          styles: {
            halign: 'left',
            fillColor: [248, 250, 252],
            fontStyle: 'italic',
            textColor: [71, 85, 105],
            fontSize: 8.5,
            cellPadding: 4
          }
        }
      ]);
    }

    return rows;
  });

  return { head, body };
};

// Ana Müşteri PDF oluşturma
const generateCustomerPDFBase = (customerInfo, orders, totalAmount, discountedTotalAmount, genelIskontoYuzde, vadeliYuzde, options = {}) => {
  const manualGrandTotal = options.manualGrandTotal || null;
  const includeMeasurements = options.includeMeasurements !== false;
  const title = options.title || 'Musteri Siparisi';
  const showPaymentInfo = options.showPaymentInfo || false;
  const showDetailedPricing = options.showDetailedPricing !== false; // Varsayılan true
  const paidAmount = options.paidAmount || 0;
  const remainingAmount = options.remainingAmount || 0;
  const closingNote = options.closingNote || null;
  const returnBlob = options.returnBlob || false;

  if (!customerInfo || orders.length === 0) {
    if (!returnBlob) alert('Müşteri bilgileri veya sipariş bulunamadı!');
    return null;
  }

  const doc = new jsPDF();
  doc.setFont('helvetica');

  // Header (Beyaz arka plan, kırmızı yazılar)
  drawHeader(doc, title, '', 'white');

  // Müşteri bilgileri
  let currentY = drawCustomerInfoBox(doc, customerInfo, 45, 'white');

  // Sipariş tablosu başlığı
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...PRIMARY_COLOR);
  doc.text('SIPARIS DETAYLARI', 20, currentY);
  currentY += 8;

  // Tablo verilerini hazırla
  const { head, body } = buildCustomerTableData(orders, includeMeasurements);

  // Tablo oluştur
  autoTable(doc, {
    startY: currentY,
    head,
    body,
    theme: 'striped',
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: PRIMARY_COLOR,
      fontStyle: 'bold',
      fontSize: 9,
      halign: 'center',
      lineColor: PRIMARY_COLOR,
      lineWidth: { top: 0.8, bottom: 0.8, left: 0.2, right: 0.2 }
    },
    styles: {
      fontSize: 9,
      cellPadding: 4,
      halign: 'center',
      lineColor: [230, 230, 230],
      lineWidth: { bottom: 0.1 }
    },
    alternateRowStyles: {
      fillColor: [250, 250, 250]
    },
    columnStyles: includeMeasurements
      ? {
        0: { cellWidth: 22 },  // Urun Tipi
        1: { cellWidth: 18 },  // Oda
        2: { cellWidth: 25 },  // Urun Adi
        3: { cellWidth: 20 },  // Olculer(cm)
        4: { cellWidth: 25 },  // Pile Modeli
        5: { cellWidth: 12, halign: 'center' },  // Adet
        6: { cellWidth: 28, halign: 'right' },   // Toplam Ucret
        7: { cellWidth: 25, halign: 'right' }    // Indirimli
      }
      : {
        0: { cellWidth: 25 },  // Urun Tipi
        1: { cellWidth: 20 },  // Oda
        2: { cellWidth: 30 },  // Urun Adi
        3: { cellWidth: 28 },  // Pile Modeli
        4: { cellWidth: 15, halign: 'center' },  // Adet
        5: { cellWidth: 28, halign: 'right' },   // Toplam Ucret
        6: { cellWidth: 25, halign: 'right' }    // Indirimli
      },
    pageBreak: 'auto',
    margin: { top: 45, right: 15, bottom: 35, left: 15 },
    didDrawPage: function (data) {
      if (data.pageNumber > 1) {
        drawHeader(doc, title + ' (Devam)', '', 'white');
      }
    }
  });

  // Toplam tutar kutusu
  let finalY = doc.lastAutoTable.finalY + 10;

  // Toplam kutusunun tahmini yüksekliğini hesapla
  const hasVadeli = vadeliYuzde && parseFloat(vadeliYuzde) > 0;
  let estimatedBoxItems = 1; // Genel toplam
  if (showDetailedPricing) {
    estimatedBoxItems += 1; // Ara toplam
    if (discountedTotalAmount !== totalAmount) estimatedBoxItems++;
    if (hasVadeli) estimatedBoxItems += 2;
    if (genelIskontoYuzde && parseFloat(genelIskontoYuzde) > 0) estimatedBoxItems += 2;
  }
  if (showPaymentInfo) estimatedBoxItems += 2;
  const estimatedBoxHeight = 20 + (estimatedBoxItems * 10);

  // Sayfa kontrolü - footer için 35px, kutu için tahmini yükseklik
  const pageHeight = doc.internal.pageSize.height;
  if (finalY + estimatedBoxHeight > pageHeight - 40) {
    doc.addPage();
    drawHeader(doc, title, '', 'white');
    finalY = 50;
  }

  const afterBoxY = drawTotalBox(doc, totalAmount, discountedTotalAmount, genelIskontoYuzde, vadeliYuzde, finalY, showPaymentInfo, paidAmount, remainingAmount, showDetailedPricing, manualGrandTotal);

  // Kapanış notu (ör. Teklif Formu)
  if (closingNote) {
    let noteY = afterBoxY + 8;
    if (noteY > pageHeight - 40) {
      doc.addPage();
      drawHeader(doc, title, '', 'white');
      noteY = 55;
    }
    doc.setFontSize(10);
    doc.setFont('helvetica', 'italic');
    doc.setTextColor(...PRIMARY_COLOR);
    doc.text(cleanTurkishChars(closingNote), 15, noteY);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0, 0, 0);
  }

  // Tüm sayfalara footer ekle
  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    drawFooter(doc);
  }

  const pdfBlob = doc.output('blob');
  if (returnBlob) {
    return pdfBlob;
  }

  // PDF'i yeni sekmede aç
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl, '_blank');
};

// Müşteri PDF oluşturma
export const generateCustomerPDF = (customerInfo, orders, totalAmount, discountedTotalAmount, genelIskontoYuzde, vadeliYuzde, paidAmount = 0, remainingAmount = 0, manualGrandTotal = null) => {
  return generateCustomerPDFBase(customerInfo, orders, totalAmount, discountedTotalAmount, genelIskontoYuzde, vadeliYuzde, {
    includeMeasurements: true,
    title: 'Siparis Detayi',
    showPaymentInfo: true,
    showDetailedPricing: false, // Müşteri detayda detaylı fiyat gizle
    paidAmount,
    remainingAmount,
    manualGrandTotal
  });
};

// Müşteri PDF Blob döndür (WhatsApp paylaşımı için)
export const generateCustomerPDFBlob = (customerInfo, orders, totalAmount, discountedTotalAmount, genelIskontoYuzde, vadeliYuzde, paidAmount = 0, remainingAmount = 0, manualGrandTotal = null) => {
  return generateCustomerPDFBase(customerInfo, orders, totalAmount, discountedTotalAmount, genelIskontoYuzde, vadeliYuzde, {
    includeMeasurements: true,
    title: 'Siparis Detayi',
    showPaymentInfo: true,
    showDetailedPricing: false,
    paidAmount,
    remainingAmount,
    manualGrandTotal,
    returnBlob: true
  });
};

// Müşteri (Sipariş öncesi) PDF oluşturma - en/boy bilgisi olmadan
export const generateCustomerPreOrderPDF = (customerInfo, orders, totalAmount, discountedTotalAmount, genelIskontoYuzde, vadeliYuzde, manualGrandTotal = null) => {
  return generateCustomerPDFBase(customerInfo, orders, totalAmount, discountedTotalAmount, genelIskontoYuzde, vadeliYuzde, {
    includeMeasurements: false,
    title: 'Teklif Formu',
    showPaymentInfo: false,
    showDetailedPricing: true, // Teklif formunda detaylı fiyat göster
    closingNote: 'Teklifimizi olumlu karsilayacaginizi umuyor, iyi calismalar diliyoruz.',
    manualGrandTotal
  });
};

// Müşteri (Sipariş öncesi) PDF Blob döndür (WhatsApp paylaşımı için)
export const generateCustomerPreOrderPDFBlob = (customerInfo, orders, totalAmount, discountedTotalAmount, genelIskontoYuzde, vadeliYuzde, manualGrandTotal = null) => {
  return generateCustomerPDFBase(customerInfo, orders, totalAmount, discountedTotalAmount, genelIskontoYuzde, vadeliYuzde, {
    includeMeasurements: false,
    title: 'Teklif Formu',
    showPaymentInfo: false,
    showDetailedPricing: true,
    closingNote: 'Teklifimizi olumlu karsilayacaginizi umuyor, iyi calismalar diliyoruz.',
    manualGrandTotal,
    returnBlob: true
  });
};

// Atölye PDF oluşturma
export const generateWorkshopPDF = (customerInfo, orders) => {
  if (!customerInfo || orders.length === 0) {
    alert('Müşteri bilgileri veya sipariş bulunamadı!');
    return;
  }

  const tulKanatOrders = orders.filter(order =>
    order.productType === 'tul' || order.productType === 'kanat'
  );

  if (tulKanatOrders.length === 0) {
    alert('Atölye PDF için Tül veya Kanat ürünü bulunamadı!');
    return;
  }

  const doc = new jsPDF();
  doc.setFont('helvetica');

  // Header - Müşteri adını büyük başlık olarak yazdır (Beyaz arka plan, kırmızı yazılar)
  drawHeader(doc, 'Atolye Siparisi', customerInfo.name, 'white');

  // Siparişler için kutular
  const cleanCustomerName = cleanTurkishChars(customerInfo.name);
  let currentY = 45;
  let currentX = 12; // Daha geniş alan için kenardan başla
  const boxWidth = 90;
  const margin = 6; // Sütunlar arası boşluğu biraz daralt
  let rowMaxHeight = 0;

  tulKanatOrders.forEach((order) => {
    const cleanNotes = cleanTurkishChars(order.notes || '');
    const extraItems = buildWorkshopOrderExtraLines(order);
    const noteLines = cleanNotes ? splitTextToLines(cleanNotes, 42) : [];
    const boxHeight = calcWorkshopBoxHeight(extraItems, noteLines);

    if (currentY + boxHeight > 270) {
      doc.addPage();
      drawHeader(doc, 'Atolye Siparisi', customerInfo.name, 'white');
      currentY = 45;
      currentX = 12;
    }

    // Kutu arka planı ve kenarlığı (Beyaz arka plan, Kırmızı çerçeve)
    doc.setFillColor(255, 255, 255);
    doc.setDrawColor(...PRIMARY_COLOR);
    doc.setLineWidth(0.5);
    doc.roundedRect(currentX, currentY, boxWidth, boxHeight, 3, 3, 'FD');

    // Üst şerit ayırıcı çizgi
    doc.setDrawColor(...PRIMARY_COLOR);
    doc.setLineWidth(0.4);
    doc.line(currentX, currentY + 14, currentX + boxWidth, currentY + 14);

    // Üst şerit metinleri - Müşteri adı + Oda adı (Kırmızı)
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...PRIMARY_COLOR);

    const cleanRoomName = cleanTurkishChars(order.roomName || '');
    // Sol: Müşteri Adı, Sağ: Oda adı
    doc.text(cleanCustomerName.substring(0, 25), currentX + 4, currentY + 9);
    doc.setFontSize(8);
    doc.setTextColor(...PRIMARY_COLOR);
    doc.text(cleanRoomName, currentX + boxWidth - 4, currentY + 9, { align: 'right' });

    // İçerik
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10);

    let fullProductName = order.productName || '';
    if (order.productVariant) fullProductName += ` - ${order.productVariant}`;
    const cleanProductName = cleanTurkishChars(fullProductName) + (order.direction ? cleanTurkishChars(` (${order.direction})`) : '');
    const cleanPileModel = cleanTurkishChars(order.pileModel || '');

    doc.text(`Urun: ${cleanProductName.substring(0, 28)}`, currentX + 4, currentY + 20);
    doc.text(`Pile: ${cleanPileModel.substring(0, 25)}`, currentX + 4, currentY + 28);
    doc.setFont('helvetica', 'bold');
    doc.text(`En: ${order.width || '-'} cm  Boy: ${order.height || '-'} cm  Adet: ${order.quantity || '1'}`, currentX + 4, currentY + 36);

    // Ek bilgiler (alt etek katlama, özel tasarım, astar, aksesuar)
    let contentY = currentY + 44;
    if (extraItems.length > 0) {
      doc.setFontSize(9);
      doc.setFont('helvetica', 'normal');
      extraItems.forEach((item) => {
        if (item.spacer) {
          contentY += 5;
          return;
        }
        const textColor = item.color === 'primary' ? PRIMARY_COLOR : [0, 0, 0];
        doc.setTextColor(...textColor);
        doc.setFont('helvetica', item.bold ? 'bold' : 'normal');
        const wrapped = splitTextToLines(item.text, 42);
        wrapped.slice(0, 2).forEach((wrappedLine) => {
          doc.text(wrappedLine, currentX + 4, contentY);
          contentY += 5;
        });
      });
      doc.setTextColor(0, 0, 0);
    }

    // Not alanı — ek bilgilerin altında
    if (cleanNotes) {
      if (extraItems.length > 0) contentY += 5;
      doc.setFontSize(9);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(...GRAY_TEXT);
      doc.text('Not:', currentX + 4, contentY);
      contentY += 5;
      noteLines.slice(0, 3).forEach((line) => {
        doc.text(line, currentX + 4, contentY);
        contentY += 5;
      });
    }

    doc.setTextColor(0, 0, 0);

    // Sonraki kutu pozisyonu
    rowMaxHeight = Math.max(rowMaxHeight, boxHeight);
    currentX += boxWidth + margin;

    if (currentX + boxWidth > 200) {
      currentX = 12;
      currentY += rowMaxHeight + 10;
      rowMaxHeight = 0;
    }
  });

  // Tüm sayfalara footer ekle
  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    drawFooter(doc);
  }

  // PDF'i yeni sekmede aç
  const pdfBlob = doc.output('blob');
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl, '_blank');
};

// Montaj PDF oluşturma
export const generateInstallationPDF = (customerInfo, orders) => {
  if (!customerInfo || orders.length === 0) {
    alert('Müşteri bilgileri veya sipariş bulunamadı!');
    return;
  }

  const doc = new jsPDF();
  doc.setFont('helvetica');

  // Header (Beyaz arka plan, kırmızı yazılar)
  drawHeader(doc, 'Montaj Siparisi', '', 'white');

  // Müşteri bilgileri kutusu
  let currentY = drawCustomerInfoBox(doc, customerInfo, 45, 'white');

  // Sipariş listesi başlığı
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...PRIMARY_COLOR);
  doc.text('MONTAJ LISTESI', 20, currentY);
  currentY += 8;

  // Siparişleri oda gruplarına göre sırala
  const sortedOrders = [...orders].sort((a, b) => {
    const roomGroupA = (a.roomName || '').substring(0, 3).toUpperCase();
    const roomGroupB = (b.roomName || '').substring(0, 3).toUpperCase();

    if (roomGroupA !== roomGroupB) {
      return roomGroupA.localeCompare(roomGroupB, 'tr-TR');
    }

    const roomCompare = (a.roomName || '').localeCompare(b.roomName || '', 'tr-TR');
    if (roomCompare !== 0) return roomCompare;

    return (a.productType || '').localeCompare(b.productType || '', 'tr-TR');
  });

  // Tablo verileri
  const tableData = sortedOrders.flatMap((order) => {
    const cleanProductType = cleanTurkishChars(PRODUCT_TYPES[order.productType]?.label || order.productType || '');
    const cleanRoomName = cleanTurkishChars(order.roomName || '');

    // Plise için detaylı satır bazlı genişletme
    if (order.productType === 'plise' && Array.isArray(order.pliseItems) && order.pliseItems.length > 0) {
      const p1Base = cleanTurkishChars(order.pliseProduct1Name || '');
      const p2Base = order.pliseProduct2Name ? ` + ${cleanTurkishChars(order.pliseProduct2Name)}` : '';

      return order.pliseItems.map((item) => {
        const ms = item.multisistem ? ' (Multisistem)' : '';
        const namePart = item.multisistem ? (p1Base + p2Base + ms) : p1Base;
        const dimensionPart = ` [${item.width} x ${item.height}] - ${item.quantity} Adet`;
        const fullProductName = namePart + cleanTurkishChars(dimensionPart);

        return [
          cleanRoomName,
          cleanProductType,
          fullProductName,
          `${item.width || '-'}`,
          `${item.height || '-'}`
        ];
      });
    }

    // Diğer ürünler için
    let productName = order.productName || '';
    if (order.productVariant) productName += ` - ${order.productVariant}`;
    const cleanProductName = cleanTurkishChars(productName) + (order.direction ? cleanTurkishChars(` (${order.direction})`) : '');

    const noHeight = order.productType === 'raySistemi' || order.productType === 'rustik';

    return [[
      cleanRoomName,
      cleanProductType,
      cleanProductName,
      `${order.width || '-'}`,
      noHeight ? '-' : `${order.height || '-'}`
    ]];
  });

  // Tablo oluştur
  autoTable(doc, {
    startY: currentY,
    head: [['Oda', 'Urun Tipi', 'Urun Adi', 'En (cm)', 'Boy (cm)']],
    body: tableData,
    theme: 'striped',
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: PRIMARY_COLOR,
      fontStyle: 'bold',
      fontSize: 10,
      halign: 'center',
      lineColor: PRIMARY_COLOR,
      lineWidth: { top: 0.8, bottom: 0.8, left: 0.2, right: 0.2 }
    },
    styles: {
      fontSize: 10,
      cellPadding: 5,
      lineColor: [230, 230, 230],
      lineWidth: { bottom: 0.1 }
    },
    alternateRowStyles: {
      fillColor: [250, 250, 250]
    },
    columnStyles: {
      0: { cellWidth: 40 },
      1: { cellWidth: 38 },
      2: { cellWidth: 62 },
      3: { cellWidth: 20, halign: 'center' },
      4: { cellWidth: 20, halign: 'center' }
    },
    margin: { top: 45, right: 15, bottom: 35, left: 15 },
    didDrawPage: function (data) {
      if (data.pageNumber > 1) {
        drawHeader(doc, 'Montaj Siparisi (Devam)', '', 'white');
      }
    }
  });

  // Tüm sayfalara footer ekle
  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    drawFooter(doc);
  }

  // PDF'i yeni sekmede aç
  const pdfBlob = doc.output('blob');
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl, '_blank');
};
